import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ErrorBoundary extends Component {
  state = { error: null, errorInfo: null };
  static propTypes = { children: PropTypes.node };

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
  }

  render() {
    return this.state.errorInfo ? (
      <p className="w-100 d-flex justify-content-center align-items-center p-5">
        Something went wrong. Try to refresh this page. If the problem persists,
        please contact your administrator or us at support@elevat-iot.com.
      </p>
    ) : (
      this.props.children
    );
  }
}
